import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import {
  NEW_NEXT,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import ApplicationId from '../../components/ApplicationId';
import imgComplete from '../../assets/images/complete.svg';

const PreApproved = (props) => {
  const config = useConfig();
  const { navigate, checkinData, params, searchParams } = props;

  useEffect(() => {
    const workflowType = get(params, 'workflowType');

    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${searchParams.get('key')}`);
    }
  }, []);

  useEffect(() => {
    const { fetch } = props;

    if (fetch.isDone[`${NEW_NEXT}`] && !fetch.isRunning[`${NEW_NEXT}`]) {
      const routeUrl = checkinData.data && checkinData.data.url.replace(config.hostUrl, '');
      navigate(`${routeUrl}`);
    }
  }, [checkinData]);

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} inHeadline />
      <div className="content">
        <img src={imgComplete} alt="" />
        <h1>Thank You! Your loan is now complete and in progress to be funded</h1>
        <p>
          Hi
          {' '}
          {get(checkinData, 'data.data.firstName')}
          ! Your loan will be funded directly to your provider’s account on file within a few days.
        </p>
      </div>
    </div>
  );
};

PreApproved.propTypes = {
  navigate: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  fetch: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(PreApproved);
